import React, { FC } from 'react';

import { InputNumberProps } from 'antd';
import { Rule } from 'antd/es/form';
import { NamePath } from 'antd/es/form/interface';

import { NumberInputFormItem } from '@/components';

type TMoneyAmountFormItemProps = Omit<InputNumberProps<number>, 'name'> & {
	marginBottom?: number;
	name: NamePath;
	label?: string;
	placeholder?: string;
	rules?: Rule[];
};

export const MoneyAmountFormItem: FC<TMoneyAmountFormItemProps> = ({
	marginBottom = 16,
	label,
	name,
	placeholder = 'Enter Amount',
	rules,
	...rest
}) => {
	const formatter = (value?: number): string => {
		return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
	};

	return (
		<NumberInputFormItem
			formItemProps={{
				label: label,
				name: name,
				rules: rules,
				style: { marginBottom: marginBottom },
			}}
			inputNumberProps={{
				controls: false,
				formatter: formatter,
				maxLength: 10,
				min: 0,
				parser: (value) => Number(value?.replace(/,/g, '')),
				placeholder: placeholder,
				suffix: <>USD</>,
				...rest,
			}}
		/>
	);
};
